import { Pipe, PipeTransform } from '@angular/core';

/*
DESCRIPTION::
-> a custom "pipe" that replaces \r and \n with <br /> -> used for displaying multi-line texts in read-only pages

EXAMPLE USAGE::
-> diningguidedetails/details.component.html
This syntax doesn't work because <br /> is decoded and displayed literally:
<p class="d-none d-lg-block" style="width:unset;">{{region.primaryDescription | newLine}}</p>
So use this one:
<p class="d-none d-lg-block" style="width:unset;" [innerHTML]="region.primaryDescription | newLine"></p>

FURTHER READ::
-> default in-built pipes:
https://medium.com/front-end-weekly/angular-2-let-s-talk-about-pipes-ng-filter-in-angular-1-f46319edaf73
json, slice:[startIndex]:[numberOfChars], uppercase, lowercase, number[:digitInfo], percent, date[:displayFormat], async, currency:'[CURR_CODE]'

<p>{{ dateOfBirthday | date:'ddMMyyyy' }}</p><!-- will display '13/06/1985' -->
<p>{{ dateOfBirthday | date:'longDate' }}</p><!-- will display 'June 13, 1985' -->
<p>{{ dateOfBirthday | date:'HHmmss' }}</p><!-- will display '03:45:15' -->
<p>{{ dateOfBirthday | date:'shortTime' }}</p><!-- will display '03:45 AM' -->

<p>{{ 51.5 | currency:'EUR' }}</p><! — will display 'EUR51.5' →
<p>{{ 51.5 | currency:'USD':true }}</p><! — will display '$51.5' →
<p>{{ 51.5 | currency:'USD':true:'.2' }}</p><! — will display '$51.50' →

-> creating custom pipes (add ref to app.module.ts to make it globally accessible in all .html component templates)
https://scotch.io/tutorials/create-a-globally-available-custom-pipe-in-angular-2
https://stackoverflow.com/questions/42576420/how-to-declare-a-pipe-globally-to-use-in-different-modules
https://medium.com/@riccardopolacci/angular-custom-pipes-best-practices-3de9ca77f01b
https://www.concretepage.com/angular-2/angular-2-custom-pipe-example
https://www.oodlestechnologies.com/blogs/How-to-share-component-to-multiple-modules-in-Angular2/

*/

@Pipe({
  name: 'newLine'
})
export class PipeNewLine implements PipeTransform {
  transform(value: any): any {
  //transform(value: any, [arg1, arg2, ...]): any {

    if (!value || !value.length) {
      return value;
    }

    //value = value.replace(/(\r\n)/gmi, '<br />');
    //value = value.replace(/([\r\n])/gmi, '<br />');
    //return value;

    return value.replace(/(\r\n)|([\r\n])/gmi, '<br />');
  }
}
